import type { ReactNode, Ref } from 'react';
import { MdFullscreen, MdFullscreenExit } from 'react-icons/md';
import './DataTableFullscreenControls.scss';

/** Единая кнопка входа для таблицы и составного просмотра с панелью подробностей. */
export function DataTableFullscreenButton({ onClick, ref }: { onClick: () => void; ref?: Ref<HTMLButtonElement> }) {
    return (
        <button
            ref={ref}
            type="button"
            className="dtb__icon-btn"
            title="На весь экран"
            aria-label="На весь экран"
            onClick={onClick}
            data-testid="dtb-fullscreen"
        >
            <MdFullscreen aria-hidden />
        </button>
    );
}

export function DataTableFullscreenHeader({
    title,
    titleId,
    context,
    exitLabel,
    onExit,
}: {
    title?: ReactNode;
    titleId: string;
    context?: string;
    exitLabel: string;
    onExit: () => void;
}) {
    return (
        <div className="dtb__fs-head" data-testid="dtb-fullscreen-head">
            {title && <div id={titleId} className="dtb__fs-title">{title}</div>}
            {context && <span className="dtb__fs-context" title={context}>{context}</span>}
            <div className="dtb__fs-end">
                <kbd className="dtb__fs-kbd">Esc</kbd>
                <button
                    type="button"
                    className="dtb__icon-btn dtb__icon-btn--label"
                    onClick={onExit}
                    data-testid="dtb-fullscreen-exit"
                    data-autofocus
                >
                    <MdFullscreenExit aria-hidden />
                    {exitLabel}
                </button>
            </div>
        </div>
    );
}
